const rupiahFormatter = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  maximumFractionDigits: 0,
});

export function formatCurrency(value) {
  const number = Number(value);
  return rupiahFormatter.format(Number.isFinite(number) ? number : 0);
}

export function formatPercent(value) {
  const number = Number(value);
  return `${Number.isFinite(number) ? number.toFixed(2) : '0.00'}%`;
}
